import { researchGroup } from '@stereoagency/sanity-schema';

export const researchGroupQuery = researchGroup.schema.builder
  .filter(
    'count($taxonomies) == 0 || count(taxonomies[_ref in $taxonomies]) > 0'
  )
  .pick(['slug', 'title', 'introduction', 'badges'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use(),
    researchGroupLeader: resolver.researchGroupLeader
      .resolve(['name', 'firstName', 'image'])
      .use()
  }))
  .use();
